export default __webpack_public_path__ + "cc6f362a267691222a4f18e790e92c0c.png";